import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function BoxingBagDialog(props) {

  const { open, setOpen, handleSubmit } = props

  const rules = [
    "นวม/ถุงมือ",
    "รองเท้า",
    "สนับเข่า",
    "ผ้าพันมือ",
    "ข้าพเจ้าจะใช้งานด้วยความระมัดระวัง"
  ]

  const handleClose = (e) => {
    handleSubmit(e)
    setOpen(false);
  };

  return (
    <>
      <Dialog open={open} onClose={e => handleClose(e)}>
        <DialogTitle>ลงชื่อใช้กระสอบทราย</DialogTitle>
        <DialogContent>
          <DialogContentText>
          ข้าพเจ้าขอยืนยันว่าจะใช้อุปกรณ์ต่อไปนี้ที่อยู่ในสภาพดี ไม่เป็นอันตรายต่อกระสอบทราย
          </DialogContentText>
          <FormGroup>

            {rules.map((r, index) => (<FormControlLabel key={index} required control={<Checkbox defaultChecked />} label={r} />))}
        </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button color='warning' variant='outlined' onClick={() => setOpen(false)}>ยกเลิก</Button>
          <Button color='success' variant='contained' onClick={(e) => handleClose(e)}>รับทราบและเริ่มใช้งาน</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}